import { useState } from "react";
import { Flex, Modal, Typography, Tag, Radio } from "antd";

import { updateItem } from "@/api/tasks";

import { STATUS_OPTIONS } from "@/constants/tasks";

const { Text } = Typography;

// Окно публикации задачи
const PublishModal = ({ data, statuses = [], visible, onSave, onCancel }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [selectMode, setSelectMode] = useState("only_task");

  const defaultStatus = statuses.find(({ is_default }) => is_default);
  const tag = STATUS_OPTIONS.find(
    ({ value }) => value === defaultStatus?.color
  );

  const handleCancel = () => {
    setError(null);
    onCancel();
  };

  const handleSave = async () => {
    setError(null);
    setIsLoading(true);

    try {
      const newTask = await updateItem({
        ...data,
        status_uuid: defaultStatus?.uuid,
        ...(selectMode === "all_tasks" && { publish_children: true }),
      });

      onSave(newTask);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      maskClosable={false}
      title="Опубликовать задачу"
      open={visible}
      onOk={handleSave}
      onCancel={handleCancel}
      okText="Опубликовать"
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
      width={570}
    >
      <Flex vertical gap={20}>
        <Text>
          Публикация черновика переводит его в&nbsp;статус новой задачи
          с&nbsp;тэгом{" "}
          {defaultStatus ? (
            <Tag
              color={defaultStatus?.color}
              icon={tag?.icon}
              className="tag-with-icon-color"
              style={{
                marginRight: 2,
              }}
            >
              {defaultStatus?.label || defaultStatus?.name}
            </Tag>
          ) : (
            <span>&laquo;Не&nbsp;начата&raquo;</span>
          )}
          . Перевести задачу обратно в&nbsp;черновик не&nbsp;получится.
        </Text>
        <Radio.Group
          value={selectMode}
          onChange={(e) => setSelectMode(e.target.value)}
          options={[
            { value: "only_task", label: "Опубликовать только эту задачу" },
            {
              value: "all_tasks",
              label: "Опубликовать эту и все дочерние задачи",
            },
          ]}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        />

        {error && <Text type="danger">{error}</Text>}
      </Flex>
    </Modal>
  );
};

export default PublishModal;
